<template>
  <el-card class="box-card">
    <div slot="header" class="card-head">
      <div>使用说明</div>
    </div>
    <PdfViewer url="/static/瑞家园管理系统操作手册(工厂端).pdf" :height="500"
    ></PdfViewer>
  </el-card>
</template>

<script>
export default {
  name: 'user-card'
}
</script>

<style scoped>

</style>
